module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/maindashboard/pending-leave/pending-leave.component.css
// module id = ./src/app/modules/dashboard/components/maindashboard/pending-leave/pending-leave.component.css
// module chunks = main